<div #overview class="example-container">
  <div class="row tab-row" *ngIf="hasMoreHeader">
    <div class="col-12 grid-tab" grid-tab-def>
      <ng-content select="[grid-tab-buttons]"></ng-content>
    </div>
  </div>

  <div class="rounded resp-grid grid-div" [id]="isGridTab == false ? 'main-grid-no-tabs' : 'main-grid'" #tableRef
    [ngClass]="[customStleClasses ? customStleClasses : '']">
    <div>
      <table class="table-hover w-100" mat-table [dataSource]="gridDataSourceShtiks" multiTemplateDataRows>
        <!-- arrow for inner grid start -->
        <ng-container matColumnDef="expand">
          <th mat-header-cell *matHeaderCellDef aria-label="row actions"
            [style.display]="expandable_grid ? '' : 'none'">
            &nbsp;
          </th>
          <ng-container *matCellDef="let element">
            <td mat-cell style="width: 10px" *ngIf="checkforInnerGrid(element)">
              <button style="width: 15px" [disableRipple]="true" mat-icon-button aria-label="expand row" (click)="
                  expandedElement =
                    expandedElement === element ? null : element;
                  $event.stopPropagation()
                ">
                <mat-icon style="color: black" *ngIf="expandedElement === element">keyboard_arrow_down</mat-icon>
                <mat-icon style="color: black" *ngIf="expandedElement !== element">keyboard_arrow_right</mat-icon>
              </button>
            </td>
          </ng-container>
        </ng-container>

        <!-- arrow for inner grid end-->

        <ng-container *ngIf="
            isSelectableRow &&
            (isSelectableRow == true || isSelectableRow == 'true')
          " matColumnDef="select">
          <th class="width-100" style="width: 3%" mat-header-cell *matHeaderCellDef>
            <mat-checkbox class="gridSelectionChkbx gridSelectionChkbxHeader"
              (change)="$event ? masterToggle($event.checked) : null"
              [checked]="selection.hasValue() && isAllSelected()"
              [indeterminate]="selection.hasValue() && !isAllSelected()"
              [disabled]="isMasterCheckboxDisabled()">
            </mat-checkbox>
          </th>
          <td mat-cell class="gridSelectionChkbxCell" *matCellDef="let row">
            <mat-checkbox class="gridSelectionChkbx" (click)="$event.stopPropagation()"
              (change)="$event ? rowToogle($event, row) : null" 
              [checked]="selection.isSelected(row)"
              [disabled]="isCheckboxDisabled(row)">
            </mat-checkbox>
          </td>
        </ng-container>

        <!-- <ng-container matColumnDef="row_no">
          <th mat-header-cell *matHeaderCellDef>L.No</th>
          <td mat-cell *matCellDef="let element; let i = index">{{ i + 1 }}</td>
        </ng-container> -->

        <ng-container *ngFor="let column of columnsToDisplayShtiks; let i = index">
          <ng-container *ngIf="column.isVisible">
            <ng-container *ngIf="
                !column.switch && (column.pill || column.field == 'status' || column.field == 'container_status' || column.field == 'is_active' || column.field == 'print_status');
                else noStatusCol
              " matColumnDef="{{ column.field }}">
              <th
                mat-header-cell
                *matHeaderCellDef
                [class]="column.align"
                [ngClass]="{
                  'cursor-pointer': !column.disableSorting && !notSortableCols.includes(column.field),
                  'center-aligned': !column.left,
                  'left-aligned': column.left,
                  'extra-padding-left': column.padding
                  }"
                (click)="
                (!column.disableSorting && !notSortableCols.includes(column.field))
                 ? emitSortDirection(column.field)
                 : null
                 ">
                <div class="d-flex align-items-center sorting-ui" [ngClass]="{ 'no-sort-margin': !(isallowedSort === 'true' || isallowedSort === true) }">
                  <div>{{ column.displayName }}</div>
                  <!-- hiding this bc sorting was not working properly -->
                  <div *ngIf="isallowedSort === 'true' || isallowedSort === true" class="ms-2"
                    (click)="isDivDisabled()">
                    <!-- <img
                      class="shtiks-sort"
                      src="../../../../assets/images/sorting-icon.png"
                    /> -->
                    <div class="sort-icon" [class.sort-disabled]="column.disableSorting || notSortableCols.includes(column.field)">
                      <mat-icon
                        class="cursor-pointer"
                        [ngClass]="{'active': sortOrder === 'asc' && activeSortColumn === column.field,'shown': activeSortColumn === column.field}">
                        arrow_drop_up
                      </mat-icon>
                      <mat-icon
                        class="cursor-pointer"
                        [ngClass]="{'active': sortOrder === 'desc' && activeSortColumn === column.field,'shown': activeSortColumn === column.field}">
                        arrow_drop_down
                      </mat-icon>
                    </div>
                  </div>
                </div>
              </th>
              <td class="status-cell" mat-cell *matCellDef="let element" [ngClass]="column.align">
                <button disabled [attr.status]="
                    element[column.field] == 1
                      ? 'Active'
                      : element[column.field] == 0
                      ? 'In-Active'
                      : element[column.field]
                  " mat-stroked-button>
                  {{
                  element[column.field] == "picked"
                  ? "Picked"
                  : element[column.field] == 1 ||
                  element[column.field] == true
                  ? "Active"
                  : element[column.field] == 0 ||
                  element[column.field] == false
                  ? "In-Active"
                  : element[column.field]
                  }}
                </button>
                <span *ngIf="column.taskCreatedBadge && element.task_created" class="task-created-badge"
                  title="A task has been created for this record">
                  <span class="task-created-dot"></span>Task created
                </span>
              </td>
            </ng-container>

            <ng-template #noStatusCol [ngSwitch]="column.Stiky">
              <ng-container *ngSwitchCase="'Start'" matColumnDef="{{ column.field }}">
                <th mat-header-cell *matHeaderCellDef [class]="column.align" [ngClass]="{
                 'center-aligned': !column.left,
                 'left-aligned': column.left,
                 'extra-padding-left': column.padding
                        }">
                  <div class="d-flex align-items-center sorting-ui" [ngClass]="{ 'no-sort-margin': !(isallowedSort === 'true' || isallowedSort === true) }">
                    <div>{{ column.displayName }}</div>
                  </div>
                </th>
                <td style="overflow-wrap: anywhere" mat-cell *matCellDef="let element" [class]="column.align"
                  class="text-rap" [ngClass]="{
                    sorted: sort.active == column.field && sort.direction != '',
                    'text-secondary': column.clickable
                  }">
                  <div *ngIf="
                      column.displayName !== 'SKU' ||
                      column.displayName !== 'Kit Name'
                    ">
                    {{ element[column.field] }} yes
                  </div>
                </td>
              </ng-container>

              <ng-container *ngSwitchCase="'End'" matColumnDef="{{ column.field }}">
                <th mat-header-cell *matHeaderCellDef [class]="column.align" [ngClass]="{
                 'center-aligned': !column.left,
                 'left-aligned': column.left,
                 'extra-padding-left': column.padding
                        }">
                  <div class="d-flex align-items-center sorting-ui" [ngClass]="{ 'no-sort-margin': !(isallowedSort === 'true' || isallowedSort === true) }">
                    <div>{{ column.displayName }}</div>
                  </div>
                </th>
                <td style="overflow-wrap: anywhere" mat-cell *matCellDef="let element" [class]="column.align"
                  class="text-rap" [ngClass]="{
                    sorted: sort.active == column.field && sort.direction != '',
                    'text-secondary': column.clickable
                  }">
                  {{ element[column.field] }}
                </td>
              </ng-container>

              <ng-container *ngSwitchDefault matColumnDef="{{ column.field }}">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  [class]="column.align"
                 [ngClass]="{
                  'cursor-pointer': !column.disableSorting && !notSortableCols.includes(column.field),
                  'center-aligned': !column.left,
                  'left-aligned': column.left,
                  'extra-padding-left': column.padding
                  }"
                  (click)="
                    (!column.disableSorting && !notSortableCols.includes(column.field))
                   ? emitSortDirection(column.field)
                         : null
                  "
                >
                  <div class="d-flex align-items-center sorting-ui" [ngClass]="{ 'no-sort-margin': !(isallowedSort === 'true' || isallowedSort === true) }">
                    <div>{{ column.displayName }}</div>
                    <!-- hiding this bc sorting was not working properly -->
                    <div *ngIf="isallowedSort === 'true' || isallowedSort === true" class="ms-2"
                      (click)="isDivDisabled()">
                      <!-- <img
                        class="shtiks-sort"
                        src="../../../../assets/images/sorting-icon.png"
                      /> -->
                      <!-- check if sorting is not disabled and column is not sortable then don't show sorting buttons -->
                      <div class="sort-icon" [class.sort-disabled]="column.disableSorting || notSortableCols.includes(column.field)">
                        <mat-icon
                          [ngClass]="{'active': sortOrder === 'asc' && activeSortColumn === column.field,'shown': activeSortColumn === column.field}">
                          arrow_drop_up
                        </mat-icon>
                        <mat-icon
                          [ngClass]="{'active': sortOrder === 'desc' && activeSortColumn === column.field,'shown': activeSortColumn === column.field}">
                          arrow_drop_down
                        </mat-icon>
                      </div>
                    </div>
                  </div>
                </th>

                <td style="overflow-wrap: anywhere" [ngStyle]="
                    column?.columnWidth !== undefined
                      ? { width: column?.columnWidth }
                      : {}
                  " mat-cell *matCellDef="let element; let p = dataIndex" [class]="column.align" class="text-rap"
                  [ngClass]="{
                    sorted:
                      sort?.active == column.field && sort.direction != '',
                    'text-secondary': column.clickable
                  }">
                  <ng-container *ngIf="column?.progressBar">
                    <c-progress [height]="20">
                      <c-progress-bar [value]="
                          element[column.field] == 0
                            ? 200
                            : element[column.field]
                        " [color]="
                          element[column.field] > 0 &&
                          element[column.field] < 41
                            ? 'danger'
                            : element[column.field] > 40 &&
                              element[column.field] < 71
                            ? 'info'
                            : element[column.field] > 71 &&
                              element[column.field] < 100
                            ? 'warning'
                            : element[column.field] == 100
                            ? 'success'
                            : 'secondary'
                        ">{{ element[column.field] }}%</c-progress-bar>
                    </c-progress>
                  </ng-container>

                  <ng-container *ngIf="column?.field == 'line_no'">
                    <span>{{ p + 1 }}</span>
                  </ng-container>
                  <!-- <ng-container *ngIf="column?.displayName == 'Final Count Variance'">

                    <mat-form-field
                    *ngIf="column.isEditable"
                    appearance="legacy"
                    floatLabel="never"
                  >
                    <input
                      placeholder="0"
                      type="number"
                      matInput
                      min="1"
                      max="100000"
                      [(ngModel)]="element.final_count_variance"
                      onkeydown="if(event.key==='e' || event.key==='+' || event.key==='-' || event.key==='.'){event.preventDefault();}"
                      oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');"
                    />
                  </mat-form-field>
                  <span *ngIf="!column.isEditable">{{
                    element[column.field] ? element[column.field] : "-"
                  }}</span>
                  </ng-container> -->
                  <ng-container *ngIf="column?.displayName == 'Final Count Variance'">
                    <mat-form-field *ngIf="column.isEditable" appearance="legacy" floatLabel="never">
                      <input placeholder="0" type="number" matInput [min]="-100000" max="100000"
                        [(ngModel)]="element.final_count_variances" (change)="QtyFinalCount(element)"
                        onkeydown="if(event.key==='e' || event.key==='+' || event.key==='.'){event.preventDefault();}" />
                    </mat-form-field>
                  </ng-container>

                  <ng-container *ngIf="column?.clickable_action && column.clickable">
                    <div class="d-flex flex-column"
                      (mouseenter)="checkTruncation(clickableActionRef, element[column.field])">
                      <a href="javascript:void(0)" (click)="
                          acionClick(
                            column.clickableItem
                              ? column.clickableItem
                              : 'detail',
                            element
                          );
                          $event.stopPropagation()
                        " [ngClass]="
                          element.pr_no === null
                            ? 'text-decoration-none cursor-pointer'
                            : 'cursor-pointer'
                        " class="pr" rel="noopener noreferrer" #clickableActionRef
                        [matTooltip]="column.enableTooltip && isTextTruncatedMap[element[column.field]] ? element[column.field] : ''"
                        matTooltipPosition="above">
                        {{ element[column.field] ? element[column.field] : "-" }}
                      </a>
                    </div>
                  </ng-container>

                  <ng-container *ngIf="
                      column.displayName !== 'SKU' &&
                      column.displayName !== 'Kit Name' &&
                      column.displayName !== 'Component Name' &&
                      column.displayName !== 'Kit SKU' &&
                      !column?.progressBar &&
                      column.field !== 'line_no' &&
                      !column?.clickable_action
                    ">
                    <div *ngIf="column.displayName == 'Location'" [matTooltip]="getLocationTooltipContent(element, column)" 
     [matTooltipPosition]="'above'"
     [matTooltipDisabled]="!shouldShowLocationTooltip(element, column, 'location-' + element.id + '-' + column.field) || !column.showLinesTooltip"
     (mouseenter)="checkLocationTooltipTruncation($any($event.currentTarget).querySelector('.text-truncate'), 'location-' + element.id + '-' + column.field)">
                      <ng-container *ngIf="!element.toAllowDropdown">
                        <a href="javascript:void(0)" *ngIf="column.clickableDetail" (click)="
                        acionClick(
                          column.clickableItem
                            ? column.clickableItem
                            : 'detail',
                          element
                        );
                        $event.stopPropagation()
                      " [ngClass]="
                        element.pr_no === null
                          ? 'text-decoration-none cursor-pointer'
                          : 'cursor-pointer'
                      " class="pr p-0 m-0 text-truncate d-block text-decoration-none" style="max-width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{element[column.field]}}</a>
                        <p *ngIf="!column.clickableDetail" class="p-0 m-0 text-truncate" style="max-width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{element[column.field]}}</p>
                        <ng-container *ngIf="column?.linesWith?.length">
                          <small *ngFor="let line of column.linesWith" class="d-block text-secondary"
                            >
                            <!-- value is the label of -->
                            {{getTruncatedLinesWithText(element, line, column)}}
                          </small>
                        </ng-container>
                      </ng-container>

                      <ng-container *ngIf="element.toAllowDropdown">
                        <ng-select [clearable]="false" [ngModel]="element?.location_id" [appendTo]="'body'"
                          (change)="acionClick('update', element ,$event)" appearance="outline" placeholder="Select"
                          [searchable]="true" class="d-grid mt-2 loc-dropdown">
                          <ng-option *ngFor="let item of element.locationList" [value]="item.id">
                            {{ item.name }}
                          </ng-option>
                        </ng-select>
                      </ng-container>
                    </div>

                    <div *ngIf="column.asLink">
                      <a [ngClass]="element[column.field]
                                                    ? 'text-decoration-none cursor-pointer'
                                                    : 'cursor-pointer'
                                                " class="pr" rel="noopener noreferrer" (click)="onAsLinkClick(element)">
                        {{
                        element[column.field] ? element[column.field] : "-"
                        }}
                      </a>
                    </div>

                    <div *ngIf="column.switch" [ngClass]="column.align === 'text-center' ? 'd-flex justify-content-center' : ''">
                      <app-switch
                        [checked]="element[column.field] === 1"
                        [disabled]="element.switchDisabled || false"
                        (onToggle)="onToggleChange($event, element, column.field)">
                      </app-switch>
                    </div>

                    <div *ngIf="column.withCount">
                      <p class="p-0 m-0">
                        <span *ngIf="!element[column.field]">-</span>
                        <span *ngIf="element[column.field]">
                          {{element[column.field]?.split(',')[0]}} <span class="text-primary cursor-pointer"
                            *ngIf="element[column.field]?.split(',').length > 1"
                            (click)="onCountClickHandler(element[column.field])">+{{element[column.field]?.split(',').length}}</span>
                        </span>
                      </p>
                    </div>

                    <div *ngIf="column.showMore">
                      <p class="p-0 m-0">
                        <span *ngIf="!element[column.field] || element[column.field]?.trim() === ''">-</span>
                        <span *ngIf="element[column.field] && element[column.field]?.trim() !== ''">
                          <ng-container *ngIf="getCommaSeparatedValues(element[column.field]).length > 0">
                            {{getCommaSeparatedValues(element[column.field])[0]}}
                            <span class="text-primary cursor-pointer mx-1"
                              *ngIf="getCommaSeparatedValues(element[column.field]).length > 1"
                              (click)="acionClick('toShowMore', getCommaSeparatedValues(element[column.field]), column.title || column.displayName)">
                              +{{getCommaSeparatedValues(element[column.field]).length - 1}}
                            </span>
                          </ng-container>
                        </span>
                      </p>
                    </div>

                    <div *ngIf="column.displayName === 'Identifier' || column.displayName === 'Transaction ID'" class="d-flex">
                      <ng-container *ngIf="element['identifier_details']; else simpleText">
                        <ng-container *ngIf="element['identifier_details']?.length ; else emptyValue">
                          <a [routerLink]="[getUrl(element['identifier_details'][0]?.module), element['identifier_details'][0]?.id]" [ngClass]="element.pr_no === null ? 'text-decoration-none cursor-pointer'
                                                     : 'cursor-pointer' " class="pr" rel="noopener noreferrer">
                            {{
                            element['identifier_details'] ? element['identifier_details'][0]?.name : "-"
                            }}
                          </a>
                          <a class="cursor-pointer mx-2 pr text-decoration-none" *ngIf="element['identifier_details']?.length > 1"
                            (click)="acionClick('toViewMore', element['identifier_details'])">+{{element['identifier_details']?.length -
                            1}}</a>
                        </ng-container>
                        <ng-template #emptyValue>
                          <span>{{"-"}}</span>
                        </ng-template>
                      </ng-container>
                      <ng-template #simpleText>
                        <p class="p-0 m-0" *ngIf="isArray(element[column.field])">
                          {{element[column.field][0]}} <span class="text-primary cursor-pointer" *ngIf="element[column.field]?.length > 1"
                            (click)="acionClick('toShowMore',element[column.field],'Identifiers')">+{{element[column.field]?.length -
                            1}}</span>
                        </p>
                        <p class="p-0 m-0" *ngIf="!isArray(element[column.field])">{{element[column.field] ?
                          element[column.field] : "-"}}</p>
                      </ng-template>
                    </div>

                    <div *ngIf="column.displayName === 'Job Types'">
                      <p class="p-0 m-0" *ngIf="isArray(element[column.field])">
                      {{ isArray(element[column.field]) && element[column.field].length > 0 ? element[column.field][0] : '-' }} <span class="text-primary cursor-pointer mt-2"
                          *ngIf="element[column.field]?.length > 1"
                          (click)="acionClick('toShowMore',element[column.field])">+{{element[column.field]?.length -
                          1}}</span>
                      </p>
                      <p class="p-0 m-0" *ngIf="!isArray(element[column.field])">{{element[column.field] ?
                        element[column.field] : "-"}}</p>
                    </div>

                    <div *ngIf="column.displayName === 'Task Types' || column.displayName === 'Tasks' || column.showMorePopup === true">
                      <p class="p-0 m-0" *ngIf="isArray(element[column.field])">
                      {{ isArray(element[column.field]) && element[column.field].length > 0 ? element[column.field][0] : '-' }} <span class="text-primary cursor-pointer mt-2"
                          *ngIf="element[column.field]?.length > 1"
                          (click)="acionClick('toShowMore',element[column.field], column.displayName)">+{{element[column.field]?.length -
                          1}}</span>
                      </p>
                      <p class="p-0 m-0" *ngIf="!isArray(element[column.field])">{{element[column.field] ?
                        element[column.field] : "-"}}</p>
                    </div>

                    <div *ngIf="column.displayName === 'Reference No'">
                      <div class="d-flex align-items-center w-100 overflow-hidden" #wrapRef *ngIf="isArray(element[column.field])"
                        (mouseenter)="checkTruncation(textRefArray, element[column.field][0])"
                        [matTooltip]="isTextTruncatedMap[element[column.field][0]] ? (element[column.field][0]) : ''"
                        matTooltipPosition="above">
                        <p class="p-0 m-0 text-truncate flex-grow-1" #textRefArray>{{element[column.field][0]}}</p>
                        <span class="text-primary cursor-pointer ms-1 flex-shrink-0"
                          *ngIf="element[column.field]?.length > 1"
                          (click)="acionClick('toShowMore',element[column.field], 'Reference No')">+{{element[column.field]?.length -
                          1}}</span>
                      </div>
                      <ng-container *ngIf="!isArray(element[column.field])">
                        <div class="d-flex flex-column" *ngIf="column.enableTooltipRef; else simpleRef"
                          (mouseenter)="checkTruncation(textRef, element[column.field])">
                          <div class="text-truncate" #textRef
                            [matTooltip]="isTextTruncatedMap[element[column.field]] ? element[column.field] : ''"
                            matTooltipPosition="above">
                            {{ element[column.field] || '-' }}
                          </div>
                        </div>
                        <ng-template #simpleRef>
                          <p class="p-0 m-0">{{element[column.field] ?
                              element[column.field] : "-"}}</p>
                        </ng-template>
                      </ng-container>
                    </div>

                    <div *ngIf="column.displayName === 'UOM'">
                      <ng-container *ngIf="!element.toeditableField">
                        <span>{{element[column.field] ? element[column.field] : "-"}}</span>
                      </ng-container>
                      <ng-container *ngIf="element.toeditableField">
                        <ng-select [clearable]="false" [(ngModel)]="element.uom_id" [appendTo]="'body'"
                          appearance="outline" placeholder="Select" [searchable]="true"
                          class="d-grid mt-2 loc-dropdown">
                          <ng-option *ngFor="let item of element.uom_list" [value]="item.id">
                            {{ item.name }}
                          </ng-option>
                        </ng-select>
                      </ng-container>
                    </div>
                     <div *ngIf="column.displayName === 'Source ID'">
                      <ng-container *ngIf="element[column.field]; else emptyValue">
                        <a [routerLink]="[getUrl(element['identifier']), element['record_id']]" (click)="closeDialog()"
                          [ngClass]="'text-decoration-none cursor-pointer'" class="pr" rel="noopener noreferrer">
                          {{
                          element[column.field] ? element[column.field] : "-"
                          }}
                        </a>
                      </ng-container>
                      <ng-template #emptyValue>
                        <span>{{"-"}}</span>
                      </ng-template>
                    </div>

                    <span *ngIf="column.displayName === 'Cost'">
                      <mat-form-field *ngIf="element.isEditableQty" floatLabel="never" class="w-100">
                        <span matPrefix>$&nbsp;</span>
                        <input placeholder="0" type="number" matInput min="1" [(ngModel)]="element.cost" />
                      </mat-form-field>
                      <span *ngIf="!element.isEditableQty">
                        <ng-container *ngIf="element[column.field]; else emptyValue">
                          <ng-container *ngIf="column?.signVisible">$ </ng-container>{{ element[column.field] }}
                        </ng-container>
                        <ng-template #emptyValue>-</ng-template>
                      </span>
                    </span>

                    <div *ngIf="column.displayName === 'Service Type'">
                      <ng-container *ngIf="!element.toeditableField">
                        <span>{{element[column.field] ? element[column.field] : "-"}}</span>
                      </ng-container>
                      <ng-container *ngIf="element.toeditableField">
                        <ng-select [clearable]="false" [(ngModel)]="element.service_type" [appendTo]="'body'"
                          appearance="outline" placeholder="Select" [searchable]="true"
                          class="d-grid mt-2 loc-dropdown">
                          <ng-option *ngFor="let item of element.service_type_list" [value]="item.value">
                            {{ item.name }}
                          </ng-option>
                        </ng-select>
                      </ng-container>
                    </div>

                    <div *ngIf="column.displayName === 'Valid Upto'">
                      <div class="d-flex flex-column">
                        <span>{{element[column.field] ? element[column.field] : "-"}}</span>
                        <small class="text-danger" *ngIf="element[column?.field2]">Expiring Soon</small>
                      </div>
                    </div>

                    <span *ngIf="column.displayName == 'Available'">
                      <!-- <span>{{element[column.field]}}</span> -->
                    </span>
                    <div *ngIf="column.displayName === 'Bill Amount'">
                      <div class="d-flex flex-column">
                        <span>${{element[column.field] ? element[column.field] : "-"}}</span>
                      </div>
                    </div>
                    <span *ngIf="
                        column.displayName == 'SKU Qty' ||
                        column.displayName == 'Qty'
                      ">
                      <mat-form-field *ngIf="column.isEditable || element.isEditableQuantity" appearance="legacy" floatLabel="never" class="w-100">
                        <input placeholder="0" type="number" matInput min="1" [(ngModel)]="element.quantity"
                          (change)="maxLimitForQtyGeneral(element)"
                          onkeydown="if(event.key==='e' || event.key==='+' || event.key==='-' || event.key==='.'){event.preventDefault();}"
                          oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');" />
                      </mat-form-field>
                      <span *ngIf="!column.isEditable && !element.isEditableQuantity">{{
                        element[column.field] ? element[column.field] : "-"
                        }}</span>
                    </span>


                    <span *ngIf="column.isEditableInput && !column.enableTooltip">
                      <mat-form-field *ngIf="element.isEditEnable" appearance="legacy" floatLabel="never" class="w-75">
                        <input placeholder="0" type="number" matInput min="1" [(ngModel)]="element.quantity"
                          (change)="maxLimitForQtyGeneral(element)"
                          onkeydown="if(event.key==='e' || event.key==='+' || event.key==='-' || event.key==='.'){event.preventDefault();}"
                          oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');" />
                      </mat-form-field>
                      <span *ngIf="!element.isEditEnable">{{
                        element[column.field] ? element[column.field] : "-"
                        }}</span>
                    </span>

                    <span *ngIf="column.displayName == 'Quantity'">
                      <span [ngClass]="column?.isColorField ? (element?.is_qty_green ? 'text-green' : 'text-red') : ''">
                        {{
                        element[column.field] ? (element?.is_qty_green ? element[column.field] + ' ↑' :  element[column.field] + ' ↓') : "-"
                        }}
                      </span>
                    </span>

                    <span *ngIf="column.displayName == 'Created At'">
                      <span>{{
                        element[column.field]
                        ? (element[column.field])
                        : "-"
                        }}</span>
                    </span>



                    <span *ngIf="column.dollarValue == true">
                      <span>{{
                        element[column.field]
                        ? '$ ' + element[column.field]
                        : "-"
                      }}</span>
                    </span>

                    <span *ngIf="column.displayName == 'Discrepancy' || column.displayName.includes('Discrepancy')">
                      <ng-container *ngIf="element[column.field] ; else emptyValue">
                        <button *ngIf="!isArray(element[column.field])" disabled [attr.status]="element[column.field] ? 'discrepancy-type' : ''"
                          mat-stroked-button>
                          {{ element[column.field] ? (element[column.field]) : "-" }}
                        </button>
                      </ng-container>
                      <ng-template #emptyValue>
                        <span>{{"-"}}</span>
                      </ng-template>
                      <div class="d-flex justify-content-start align-items-end" *ngIf="isArray(element[column.field])">
                        <ng-container *ngIf="element[column.field].length ; else emptyValue">
                          <button disabled [attr.status]="element[column.field] && element[column.field].length ? 'discrepancy-type' : ''"
                            mat-stroked-button>
                            {{ element[column.field] && element[column.field].length > 0 ? element[column.field][0] : "-"
                            }}
                          </button>
                        </ng-container>
                          <ng-template #emptyValue>
                            <span>{{"-"}}</span>
                          </ng-template>

                        <!-- Menu button showing total count of elements in array -->
                        <a class="cursor-pointer mx-2 pr text-decoration-none" *ngIf="element[column.field]?.length > 1"
                          (click)="acionClick('toShowMore',element[column.field])">+{{element[column.field]?.length -
                          1}}</a>

                      </div>

                    </span>

                    <span *ngIf="column.displayName == 'Related Count Type'">
                      <button *ngIf="!isArray(element[column.field])" disabled
                        [attr.status]="element[column.field] ? 'discrepancy-type' : ''" mat-stroked-button>
                        {{ element[column.field] ? (element[column.field]) : "-" }}
                      </button>
                      <div class="d-flex justify-content-start align-items-end" *ngIf="isArray(element[column.field])">
                        <!-- Button displaying first element or "-" if array is empty -->
                        <button [disabled]="element[column.field]?.length < 1"
                          (click)="acionClick('toRedirectCountType',element[column.field][0])" mat-stroked-button>
                          {{ element[column.field] && element[column.field].length > 0 ? element[column.field][0]?.name
                          : "-" }}
                        </button> <span *ngIf="element[column.field]?.length > 1" class="mx-1"> ... </span>

                        <!-- Menu button showing total count of elements in array -->
                        <button mat-button [matMenuTriggerFor]="menuD" class="rounded-button"
                          *ngIf="element[column.field]?.length > 1">
                          +{{ element[column.field]?.length - 1 || 0 }}
                        </button>

                        <!-- Menu with items displayed if array has values -->
                        <mat-menu #menuD="matMenu">
                          <button *ngFor="let option of element[column.field]" mat-menu-item
                            style="color: black; opacity:1" (click)="acionClick('toRedirectCountType',option)">{{
                            option?.name }}</button>
                        </mat-menu>
                      </div>

                    </span>

                    <!-- Concat fields start -->
                    <div *ngIf="column.isConcat">
                      <div class="d-flex flex-column"
                        *ngIf="element[column.field] || element[column.concatField]; else empty"
                        matTooltip="{{ element[column.field] ? element[column.field] + '&#10;' : '' }}{{ element[column.concatField] || ''}}"
                        [matTooltipPosition]="'left'">
                        <div class="text-truncate">
                          {{element[column.field] || '-'}}
                        </div>
                        <div class="text-truncate">
                          {{element[column.concatField] || '-'}}
                        </div>
                      </div>
                      <ng-template #empty>
                        {{'-'}}
                      </ng-template>
                    </div>
                    <!-- Concat fields end -->

                    <!-- <div *ngIf="column.isJson">
                      <div class="d-flex flex-column" *ngIf="element[column.field]; else empty"
                        (mouseenter)="checkTruncation(textRef, element[column.field])">
                        <div class="text-truncate cursor-pointer" #textRef
                          [matTooltip]="formatJson(element[column.field])"
                          matTooltipClass="json-tooltip"
                          matTooltipPosition="above">
                          {{ element[column.field] || '-' }}
                        </div>
                      </div>
                      <ng-template #empty>
                        {{ '-' }}
                      </ng-template>
                    </div> -->

<div *ngIf="column.isJson">
  <ng-container *ngIf="element[column.field]; else empty">

    <mat-icon class="cursor-pointer json-icon" (click)="openJsonViewer(element[column.field])"
      matTooltipClass="json-tooltip" matTooltipPosition="above">
      visibility
    </mat-icon>

  </ng-container>

  <ng-template #empty>
    -
  </ng-template>
</div>

                    <div *ngIf="column.enableTooltip == true && !column.isJson && !column.isTrackingInformation">
                      <ng-container *ngIf="column.isEditableInput && element.isEditEnable; else simpleField" >
                        <mat-form-field *ngIf="element.isEditEnable" appearance="outline" class="w-100 example-full-width ">
                          <input placeholder="-" matInput [(ngModel)]="element.description" />
                        </mat-form-field>
                        <span *ngIf="!element.isEditEnable">{{
                          element[column.field] ? element[column.field] : "-"
                          }}</span>
                      </ng-container>
                      <ng-template #simpleField>
                        <ng-container *ngIf="element[column.field] || element[column.concatField]; else empty">
                          <div *ngIf="column.clickable" class="d-flex flex-column"
                            (mouseenter)="checkTruncation(tooltipLinkRef, element[column.field])">
                            <a [routerLink]="[activeURL, element['id']]"
                              (click)="acionClick(column.clickableItem ? column.clickableItem : 'detail', element); $event.stopPropagation()"
                              class="text-truncate pr cursor-pointer d-block" #tooltipLinkRef
                              [matTooltip]="isTextTruncatedMap[element[column.field]] ? element[column.field] + '\n' + (element[column.concatField] || '') : ''"
                              matTooltipPosition="above">
                              {{ element[column.field] || '-' }}
                            </a>
                          </div>
                          <div *ngIf="!column.clickable" class="d-flex flex-column"
                            (mouseenter)="checkTruncation(textRef, element[column.field])">
                            <div class="text-truncate" #textRef
                              [matTooltip]="isTextTruncatedMap[element[column.field]] ? element[column.field] + '\n' + (element[column.concatField] || '') : ''"
                              matTooltipPosition="above">
                              {{ element[column.field] || '-' }}
                            </div>
                          </div>
                        </ng-container>
                        <ng-template #empty>
                          {{ '-' }}
                        </ng-template>
                      </ng-template>
                    </div>

                    <span *ngIf="column.displayName == 'Created Date/Time'">
                      <span>
                        {{
                        element[column.field]
                        ? (element[column.field])
                        : "-"
                        }}
                      </span>
                    </span>

                    <!-- <span *ngIf="column.displayName == 'Batch/Lot/Tag'">
                      <span>{{ combineBatchLotTag(element) }}</span>
                    </span> -->

                    <span *ngIf="
                        column.displayName == 'Date Created' &&
                        element[column.field]
                      ">
                      <span>{{
                        element[column.field]
                        }}</span>
                    </span>

                    <span *ngIf="column.displayName == 'Future'">
                      <button *ngIf="!element.isIncoming" mat-icon-button style="text-align: center" (click)="
                          getInventoryCount(element, element.id, 'incoming');
                          $event.stopPropagation()
                        ">
                        <mat-icon style="color: black">sync</mat-icon>
                      </button>

                      <span *ngIf="element.isIncoming">{{
                        element.incoming_qty ? element.incoming_qty : "0"
                        }}</span>
                      <!-- <div *ngIf="toShow" back-icon (click)="detail()" id="bk" class="cursor-pointer"><i class="icon-arrow-back"></i></div> -->
                    </span>

                    <span *ngIf="column.displayName == 'Incoming'">
                      <!-- <button *ngIf="!element.isIncoming" mat-icon-button style="text-align: center" (click)="
                          getInventoryCount(element, element.id, 'incoming');
                          $event.stopPropagation()
                        ">
                        <mat-icon style="color: black">sync</mat-icon>
                      </button> -->

                      <span>{{ element[column.field] || '-' }}</span>
                      <!-- <div *ngIf="toShow" back-icon (click)="detail()" id="bk" class="cursor-pointer"><i class="icon-arrow-back"></i></div> -->
                    </span>

                    <span *ngIf="column.displayName == 'Intransit'">
                      <button *ngIf="!element.isIntransit" mat-icon-button style="text-align: center" (click)="
                          getInventoryCount(element, element.id, 'intransit');
                          $event.stopPropagation()
                        ">
                        <mat-icon style="color: black">sync</mat-icon>
                      </button>
                      <span *ngIf="element.isIntransit">{{
                        element.intransit_qty ? element.intransit_qty : "0"
                        }}</span>
                      <!-- <div *ngIf="toShow" back-icon (click)="detail()" id="bk" class="cursor-pointer"><i class="icon-arrow-back"></i></div> -->
                    </span>

                    <span *ngIf="column.displayName == 'Reserve'">
                      <button *ngIf="!element.isReserve" mat-icon-button style="text-align: center" (click)="
                          getInventoryCount(element, element.id, 'reserve');
                          $event.stopPropagation()
                        ">
                        <mat-icon style="color: black">sync</mat-icon>
                      </button>
                      <span *ngIf="element.isReserve">{{
                        element.reserve_qty ? element.reserve_qty : "0"
                        }}</span>
                      <!-- <div *ngIf="toShow" back-icon (click)="detail()" id="bk" class="cursor-pointer"><i class="icon-arrow-back"></i></div> -->
                    </span>

                    <span *ngIf="
                        column.displayName == 'Base Unit'
                      ">
                      <div class="custom-select poLinesSelectBox" *ngIf="column.isVisible && column.type == 'dropdown'"
                        style="margin-bottom: 1px">
                        <span>{{
                          element.base_unit ? element.base_unit : "-"
                          }}</span>

                        <!-- <ng-select [(ngModel)]="element.uom_id" [appendTo]="'body'" [clearable]="false"
                          [searchable]="false" placeholder="Select" class="line-select">
                          <ng-option *ngFor="let item of get_uom_list(element)" [value]="element.base_unit">{{ item.name
                            }}</ng-option>
                           <ng-option *ngFor="let item of uom_list" [value]="item.id">{{ item.name }}</ng-option> -->
                        <!-- </ng-select> -->
                      </div>

                      <div *ngIf="
                          column.isVisible && !column.isTrackingEnabled &&
                          (column.type == undefined || column.type == '')
                        ">
                        <a [routerLink]="[activeURL, element['id']]" *ngIf="column.clickable" (click)="
                            acionClick(
                              column.clickableItem
                                ? column.clickableItem
                                : 'detail',
                              element
                            );
                            $event.stopPropagation()
                          " [ngClass]="
                            element.pr_no === null
                              ? 'text-decoration-none cursor-pointer'
                              : 'cursor-pointer'
                          " class="pr" rel="noopener noreferrer">
                          {{
                          element[column.field] ? element[column.field] : "-"
                          }}
                        </a>
                        <span *ngIf="!column.clickable">{{
                          element[column.field]
                          ? element[column.field]
                          : element[column.field] == "0"
                          ? "0"
                          : "-"
                          }}</span>

                      </div>
                    </span>

                    <span *ngIf="
                        !column.isTrackingInformation &&
                        column.displayName !== 'SKU Qty' &&
                        column.displayName !== 'Base Unit' &&
                        column.displayName !== 'Qty' &&
                        column.displayName !== 'UOM' &&
                        column.displayName !== 'Created At' &&
                        column.displayName !== 'Date Created' &&
                        column.displayName !== 'Created Date/Time' &&
                        column.displayName !== 'Future' &&
                        column.displayName !== 'Incoming' &&
                        column.displayName !== 'Intransit' &&
                        column.displayName !== 'Reserve' &&
                        column.displayName !== 'Discrepancy' &&
                        column.enableTooltip == undefined &&
                        column.isJson == undefined &&
                        column.displayName !== 'Related Count Type' &&
                        column.displayName !== 'Location' &&
                        column.displayName !== 'Service Type' &&
                        column.displayName !== 'Valid Upto' &&
                        column.displayName !== 'Cost' &&
                        !column.withCount &&
                        !column.isEditableInput &&
                        column.displayName !== 'Identifier' &&
                        column.displayName !== 'Transaction ID' &&
                        column.showMore == undefined &&
                        column.showMorePopup == undefined &&
                        column.displayName !== 'Reference No' &&
                        column.displayName !== 'Bill Amount' &&
                        column.displayName !== 'Source ID' &&
                        column.displayName !== 'Quantity' &&
                        !column.switch &&
                        !column.asLink &&
                        !column.displayName.includes('Discrepancy') &&
                        column.displayName !== 'Job Types' &&
                        column.displayName !== 'Task Types' &&
                        column.displayName !== 'Tasks' &&
                        column.dollarValue == undefined
                      ">
                      <a [routerLink]="[activeURL, element['id']]" *ngIf="column.clickable" (click)="
                          acionClick(
                            column.clickableItem
                              ? column.clickableItem
                              : 'detail',
                            element
                          );
                          $event.stopPropagation()
                        " [ngClass]="
                          element.pr_no === null
                            ? 'text-decoration-none cursor-pointer'
                            : 'cursor-pointer'
                        " class="pr" rel="noopener noreferrer">
                        {{
                        element[column.field] ? element[column.field] : "-"
                        }}
                      </a>
                      <span *ngIf="column.boolField">{{
                        element[column.field] ? "Yes" : "No"
                        }}</span>
                      <ng-container *ngIf="column.withTag">
                        <span>{{ element[column.field] || "-" }} </span>
                        <small *ngIf="element[column.withTagField]?.length > 0" class="badge" style="background-color: #1C3343;">
                          {{ element[column.withTagField] }}
                        </small>
                      </ng-container>
                      <span
                        *ngIf="!column.clickable && !column.boolField && !column.isConcat && !column.isTrouble && !column.isTrackingEnabled && !column.withTag">
                        {{ getNestedValue(element, column.field) ?? (element[column.field] == "0" ? "0" : "-") }}
                      </span>
                    </span>

                    <span *ngIf="column?.isTrackingEnabled"
                      [ngClass]=" element[column.field]?.length>0 ? 'pr cursor-pointer' : ''"
                      (click)="trackingClick(checkFieldType(element[column.field]) == 'array' ? element[column.field] : element)">
                      <ng-container *ngIf="checkFieldType(element[column.field]) == 'array' else typestring">
                        {{
                        element[column.field].length>0
                        ? element[column.field].length
                        : "-"
                        }}
                      </ng-container>
                      <ng-template #typestring>
                        {{
                        element[column.field]
                        ? element[column.field]
                        : element[column.field] == "0"
                        ? "0"
                        : "-"
                        }}
                      </ng-template>
                    </span>

                    <span *ngIf="column?.isTrackingInformation"
                      [ngClass]="element[column.field]?.length>0 ? 'pr cursor-pointer' : ''"
                      (click)="element[column.field]?.length>0 && trackingClick(element[column.field])">
                      <ng-container *ngIf="element[column.field]?.length > 0; else emptyTrackingInfo">
                        <ng-container *ngIf="element[column.field].length == 1; else trackingCount">
                          <ng-container *ngIf="column.enableTooltip; else plainSingleTracking">
                            <div class="d-flex flex-column"
                              (mouseenter)="checkTruncation(trackingSingleRef, element[column.field][0].tracking_number)">
                              <div class="text-truncate" #trackingSingleRef
                                [matTooltip]="isTextTruncatedMap[element[column.field][0].tracking_number] ? element[column.field][0].tracking_number : ''"
                                matTooltipPosition="above">
                                {{ element[column.field][0].tracking_number }}
                              </div>
                            </div>
                          </ng-container>
                          <ng-template #plainSingleTracking>
                            {{ element[column.field][0].tracking_number }}
                          </ng-template>
                        </ng-container>
                        <ng-template #trackingCount>
                          {{ element[column.field].length }}
                        </ng-template>
                      </ng-container>
                      <ng-template #emptyTrackingInfo>
                        <ng-container *ngIf="column.enableTooltip && column.fallbackField && element[column.fallbackField]; else plainFallback">
                          <div class="d-flex flex-column"
                            (mouseenter)="checkTruncation(trackingFallbackRef, element[column.fallbackField])">
                            <div class="text-truncate" #trackingFallbackRef
                              [matTooltip]="isTextTruncatedMap[element[column.fallbackField]] ? element[column.fallbackField] : ''"
                              matTooltipPosition="above">
                              {{ element[column.fallbackField] }}
                            </div>
                          </div>
                        </ng-container>
                        <ng-template #plainFallback>
                          {{ (column.fallbackField ? element[column.fallbackField] : null) || "-" }}
                        </ng-template>
                      </ng-template>
                    </span>
                  </ng-container>

                  <div joyrideStep="step1" [nextTemplate]="nextButton" [stepContent]="customContent" *ngIf="
                      column.displayName == 'SKU' ||
                      column.displayName == 'Kit Name' ||
                      column.displayName == 'Component Name' ||
                      column.displayName == 'Kit SKU'
                    ">
                    <div class="d-flex align-items-center" (click)="
                        !column.notAsLink && acionClick(
                          column.clickableItem
                            ? column.clickableItem
                            : 'detail',
                          element
                        )
                      ">
                      <img [src]="
                          element[column.fieldprd_img]
                            ? element[column.fieldprd_img]
                            : '../../../../assets/images/default-image.png'
                        " width="33" height="33" alt="" class="pro_img cursor-pointer" (error)="handleImgError($event)"
                        *ngIf="column.fieldprd_img" />
                      <div class="d-block pl-5 sku-block"  #contentDiv [ngClass]="{'cursor-pointer': !column.notAsLink}" style="width: 100%"
                        matTooltipPosition="below" [matTooltipShowDelay]="500"  [matTooltip]="getTooltipContent(contentDiv, element, column)"
                        (click)="
                          !column.notAsLink && acionClick(
                            column.clickableItem
                              ? column.clickableItem
                              : 'detail',
                            element
                          )
                        ">
                        <p *ngIf="!column.linesWith?.length" [ngClass]="{ 'text-secondary': !column.clickable }"
                          class="mb-0 sku cursor-pointer" matTooltipHideDelay="1000">
                          {{ element[column.fieldprd_sku]}}
                        </p >
                        <a *ngIf="ModuleName == 'inventory' && !column.notAsLink" class="text-rap mb-0 cursor-pointer"
                          [ngClass]="
                            column?.isHiglighed == false ? 'pr pr-b' : 'pr'
                          " matTooltipHideDelay="1000">
                          {{
                          element[column.field] ? element[column.field] : "-"
                          }}
                        </a>
                        <div [matTooltip]="getLocationTooltipContent(element, column)" 
     [matTooltipPosition]="'above'"
     [matTooltipDisabled]="!shouldShowLocationTooltip(element, column, 'sku-' + element.id + '-' + column.field) || !column.showLinesTooltip"
     (mouseenter)="checkLocationTooltipTruncation($any($event.currentTarget).querySelector('p'), 'sku-' + element.id + '-' + column.field)">
                        <p *ngIf="column.notAsLink" class="p-0 m-0 text-truncate" style="max-width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                          {{element[column.field] ? element[column.field] : "-"}}
                        </p>
                        <ng-container *ngIf="column.linesWith?.length">
                          <small class="d-block text-secondary mb-1">
                            {{element[column.fieldprd_sku] ? element[column.fieldprd_sku] : "-"}}
                          </small>
                          <small *ngFor="let line of column.linesWith" class="d-block text-secondary">
                            <!-- value is the label of -->
                            {{getTruncatedLinesWithText(element, line, column)}}
                          </small>
                        </ng-container>
                        </div>
                        <a *ngIf="
                            ModuleName != 'inventory' &&
                            ModuleName != 'productNkit'
                          " [routerLink]="
                            column.clickable ? [activeURL, element['id']] : []
                          " class="text-rap mb-0 cursor-pointer" [ngClass]="{
                          'pr': true,
                          'pr-b': column?.isHiglighed === false,
                          'text-fiord': !column.clickable
                        }" matTooltipHideDelay="1000">
                          {{
                          element[column.field] ? element[column.field] : "-"
                          }}
                        </a>
                        <a *ngIf="ModuleName == 'productNkit'" [routerLink]="
                            column.clickable ? [activeURL, element['id']] : []
                          " [queryParams]="{ is_kit: element?.is_kit }" class="text-rap mb-0 cursor-pointer" [ngClass]="
                            column?.isHiglighed == false ? 'pr pr-b' : 'pr'
                          " matTooltipHideDelay="1000">
                          {{
                          element[column.field] ? element[column.field] : "-"
                          }}
                        </a>
                        <!-- {{element.is_kit}} -->
                      </div>
                    </div>
                  </div>

                  <div *ngIf="column.isTrouble">
                <th mat-header-cell *matHeaderCellDef [ngClass]="column.align">
                  {{ column.displayName }}
                </th>
                <span>
                  <button mat-icon-button [disabled]="!element[column.field]" style="text-align:center"
                    (click)="openPopup()">
                    <mat-icon [ngClass]="{'disableIcon': !element[column.field]}"
                      style="color:red">error_outline</mat-icon>
                  </button>
                </span>
    </div>

    <ng-template #nextButton>
      <button class="tour-skip-button" (click)="onSkipTour()">
        Skip
      </button>
      <button class="tour-next-button" #joyrideNextButton>
        Next
      </button>
    </ng-template>
    <ng-template #customContent>
      <p>Select the SKU you want to adjust.</p>
    </ng-template>
    </td>
    </ng-container>
    </ng-template>
    </ng-container>
    </ng-container>

    <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
    <ng-container matColumnDef="expandedDetail">
      <!-- [style.overflow]="isOverflowHidden ? 'hidden' : 'auto'" -->
      <ng-container *matCellDef="let element">
        <td mat-cell *ngIf="checkforInnerGrid(element)" [attr.colspan]="initColumns.length">
          <div class="example-element-detail" [@detailExpand]="
                  element == expandedElement ? 'expanded' : 'collapsed'
                ">
            <table class="table-hover w-100" mat-table [dataSource]="innerGridData">
              <ng-container *ngFor="let column of innerGridColums; let i = index">
                <ng-container matColumnDef="{{ column?.field }}">
                  <th mat-header-cell *matHeaderCellDef>
                    {{ column?.displayName }}
                  </th>
                  <td mat-cell *matCellDef="let element" [ngStyle]="
                          column?.columnWidth !== undefined
                            ? { width: column?.columnWidth }
                            : {}
                        ">
                    <div>
                      {{
                      element[column.field] ? element[column.field] : "-"
                      }}
                    </div>
                  </td>
                </ng-container>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="innerGridColumsName"></tr>
              <tr mat-row *matRowDef="let row; columns: innerGridColumsName"></tr>
            </table>
            <!-- <div>
                  <tr *ngFor="let row of innerGridData" class="innerGrid">
                    <td
                      *ngFor="
                        let column of columnsToDisplayShtiks;
                        let isFirst = first;
                        let isLast = last
                      "
                    >
                      <ng-container *ngIf="isFirst; else notFirst">
                        <a
                          (click)="innerGridClick(row)"
                          [ngStyle]="{ width: column.columnWidth }"
                        >
                          {{ row[column.field]?.toString() || "-" }}</a
                        >
                      </ng-container>

                      <ng-template #notFirst>
                        <ng-container *ngIf="isLast; else notLast">
                          <button
                            disabled
                            mat-stroked-button
                            [ngStyle]="{ width: column.columnWidth }"
                          >
                            {{ row[column.field]?.toString() || "-" }}
                          </button>
                        </ng-container>


                        <ng-template
                          #notLast
                          style="overflow-wrap: anywhere"
                          [class]="column.align"
                          class="text-rap"
                          [ngStyle]="{ width: column.columnWidth }"
                        >
                          {{ row[column.field]?.toString() || "-" }}
                        </ng-template>
                      </ng-template>
                    </td>
                  </tr>
                </div> -->
          </div>
        </td>
      </ng-container>
    </ng-container>

    <ng-container matColumnDef="delete">
      <th mat-header-cell class="text-center" *matHeaderCellDef>
        Action
      </th>
      <td mat-cell align="center" *matCellDef="let element; let q = dataIndex">
        <button mat-icon-button (click)="acionClick('deleteBtn', element)">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="edit">
      <th mat-header-cell class="text-center" *matHeaderCellDef>
        Action
      </th>
      <td mat-cell align="center" *matCellDef="let element; let q = dataIndex">
        <button mat-icon-button (click)="acionClick('edit', element)">
          <mat-icon>edit</mat-icon>
        </button>
      </td>
    </ng-container>

    <!-- Pivot Column -->
    <ng-container matColumnDef="pivot">
      <th mat-header-cell class="text-center" *matHeaderCellDef>
        <img *ngIf="hasMoreHeader" id="btn-clmfilter" src="../../../../assets/images/plus icon purple.svg"
          (click)="gridColumnFilter($event)" alt="" />
      </th>
      <td mat-cell align="center" *matCellDef="let element; let q = dataIndex">
        <button mat-icon-button *ngIf="isActionColVisible" [disabled]="
                isallowedAction === 'false' ||
                isallowedAction === false ||
                element?.disabled ||
                !hasMenuActions(element)
              " [matMenuTriggerFor]="matMenu" aria-label="Example icon-button with a menu">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #matMenu="matMenu">
          <button *ngIf="element.toCheckOut" mat-menu-item (click)="acionClick('checkout', element)">
            <span>Print BOL & Check Out</span>
          </button>
          <button *ngIf="element.toAccess" mat-menu-item (click)="acionClick('access', element)">
            <span>Access Account</span>
          </button>
          <button *ngIf="element.clone" mat-menu-item (click)="acionClick('clone', element)">
            <span>Clone</span>
          </button>
          <button *ngIf="element.toInactive" mat-menu-item (click)="acionClick('inactive', element)">
            <span>Inactive</span>
          </button>
          <button *ngIf="element.toresetPassword" mat-menu-item (click)="acionClick('resetPassword', element)">
            <span>Reset Password</span>
          </button>
          <button *ngIf="element.toForgotPassword" mat-menu-item (click)="acionClick('forgotPassword', element)">
            <span>Forgot Password</span>
          </button>
          <button *ngIf="element.toSendInvitation" mat-menu-item (click)="acionClick('sendInvitation', element)">
            <span>Send Invitation</span>
          </button>
          <button *ngIf="element.toactive" mat-menu-item (click)="acionClick('active', element)">
            <span>Active</span>
          </button>
          <button *ngIf="element.toMarkActive" mat-menu-item (click)="acionClick('markActive', element)">
            <span>Mark as Active</span>
          </button>
          <button *ngIf="element.toMarkInactive" mat-menu-item (click)="acionClick('markInactive', element)">
            <span>Mark as Inactive</span>
          </button>
          <button *ngIf="element.toCheckIn" mat-menu-item (click)="acionClick('checkIn', element)">
            <span>Check In</span>
          </button>
          <button *ngIf="element.toCheckOutPackShip" mat-menu-item (click)="acionClick('checkOutPackShip', element)">
            <span>Check Out</span>
          </button>
          <button *ngIf="element.toPrintPickTicket" mat-menu-item (click)="acionClick('printPickTicket', element)">
            <span>Print Pick Ticket</span>
          </button>
          <button *ngIf="element.toPrintTicket" mat-menu-item (click)="acionClick('printTicket', element)">
            <span>Print Pick/Pack Ticket</span>
          </button>
          <button *ngIf="element.toPrintPackTicket" mat-menu-item (click)="acionClick('printPackTicket', element)">
            <span>Print Pack Ticket</span>
          </button>
          <button *ngIf="element.toPrintAsn" mat-menu-item (click)="acionClick('printAsn', element)">
            <span>Print ASN</span>
          </button>
          <button *ngIf="element.toPrintShipingLabel" mat-menu-item (click)="acionClick('printShipingLabel', element)">
            <span>Print Shipping Label</span>
          </button>
          <button *ngIf="element.toReprint" mat-menu-item (click)="acionClick('reprint', element)">
            <span>Reprint</span>
          </button>
          <button *ngIf="element.toCreateTask" mat-menu-item (click)="acionClick('createTask', element)">
            <span>Create Task</span>
          </button>
          <button *ngIf="element.toCreateShipment" mat-menu-item (click)="acionClick('createShipment', element)">
            <span>Create Shipment</span>
          </button>
          <button *ngIf="element.toAddAsn" mat-menu-item (click)="acionClick('addAsn', element)">
            <span>Add ASN</span>
          </button>
          <button *ngIf="element.toDuplicate" mat-menu-item (click)="acionClick('duplicate', element)">
            <span>Duplicate</span>
          </button>
          <button *ngIf="element.toEdit" mat-menu-item (click)="acionClick('edit', element)">
            <span>Edit</span>
          </button>
          <button *ngIf="element.toEditReference" mat-menu-item (click)="acionClick('editReference', element)">
            <span>Edit Reference 2</span>
          </button>
          <button *ngIf="element.toUpdateTracking" mat-menu-item (click)="acionClick('updateTracking', element)">
            <span>Update Tracking</span>
          </button>
          <button *ngIf="element.toImportInventory" mat-menu-item (click)="acionClick('importInventory', element)">
            <span>Import Inventory</span>
          </button>
          <button *ngIf="element.toRecount" mat-menu-item (click)="acionClick('recount', element)">
            <span>{{element.recountBtn}} Count</span>
          </button>
          <button *ngIf="element.toApproveInventory" mat-menu-item (click)="acionClick('approveInventory', element)">
            <span>Approved & Adjust Inventory</span>
          </button>
          <button *ngIf="element.toCloseRecount" mat-menu-item (click)="acionClick('closeRecount', element)">
            <span>Close without Inventory Adjustment</span>
          </button>
          <button *ngIf="element.toPrintASN" mat-menu-item (click)="acionClick('printASN', element)">
            <span>Print ASN</span>
          </button>
          <button *ngIf="element.toPrintLocation" mat-menu-item (click)="acionClick('printLocation', element)">
            <span>Print Location</span>
          </button>

          <button *ngIf="element.toPrint" mat-menu-item (click)="acionClick('print', element)">
            <span style="text-transform: math-auto;">Print Label(s)</span>
          </button>

          <button *ngIf="element.toDelete" mat-menu-item (click)="deleteWarning(element)">
            <span>Delete</span>
          </button>
          <button *ngIf="element.toArchive" mat-menu-item (click)="acionClick('archive', element)">
            <span>Archive</span>
          </button>
          <button *ngIf="element.toDeleteDirect" mat-menu-item (click)="acionClick('deleteDirect', element)">
            <span>Delete</span>
          </button>
          <button *ngIf="element.toAssign" mat-menu-item (click)="acionClick('assign', element)">
            <span>Assign</span>
          </button>
          <button *ngIf="element.toAssignOrder" mat-menu-item (click)="acionClick('assignOrder', element)">
            <span>Assign Order</span>
          </button>
          <button *ngIf="element.toReAssign" mat-menu-item (click)="acionClick('assign', element)">
            <span>Re-Assign</span>
          </button>
          <button *ngIf="element.toExecute" mat-menu-item (click)="acionClick('execute', element)">
            <span>Execute</span>
          </button>
          <button *ngIf="element.toApprove" mat-menu-item (click)="acionClick('approve', element)">
            <span>Approve</span>
          </button>
          <button *ngIf="element.toAuthorize" mat-menu-item (click)="acionClick('authorize', element)">
            <span>Authorize</span>
          </button>
          <button *ngIf="element.toReject" mat-menu-item (click)="acionClick('reject', element)">
            <span>Reject</span>
          </button>
          <button *ngIf="element.toCancel" mat-menu-item (click)="acionClick('cancel', element)">
            <span>Cancel</span>
          </button>
          <button *ngIf="element.toEditLocation" mat-menu-item (click)="acionClick('editLocation', element)">
            <span>Edit Location</span>
          </button>
          <button *ngIf="element.toCreateFulfillment" mat-menu-item (click)="acionClick('createFulfillment', element)">
            <span>Create Fulfillment</span>
          </button>
          <button *ngIf="element.toDetail" mat-menu-item (click)="acionClick('view-detail', element)">
            <span>View Detail</span>
          </button>
          <button *ngIf="element.toBill" mat-menu-item (click)="acionClick('bill', element)">
            <span>Bill</span>
          </button>
          <button *ngIf="element.toDownloadTransactionLog" mat-menu-item (click)="acionClick('downloadTransactionLog', element)">
            <span>Transaction Log</span>
          </button>
          
          <!-- <button *ngIf="element.toDelete" mat-menu-item (click)="
                  acionClick('delete', element); $event.stopPropagation()
                ">
                <span>Delete</span>
              </button> -->
          <!-- <button mat-menu-item (click)="
                  acionClick('comment', element); $event.stopPropagation()
                ">
                <span>Comment</span>
              </button> -->
          <!-- <button *ngIf="showWSbuttons" mat-menu-item (click)="
                  acionClick('createArea', element); $event.stopPropagation()
                ">
                <span>Create Area</span>
              </button>
              <button *ngIf="showAreabuttons" mat-menu-item (click)="
                  acionClick('createLocation', element); $event.stopPropagation()
                ">
                <span>Create Location</span>
              </button> -->
        </mat-menu>
      </td>
    </ng-container>
    <!-- Symbol Column -->
    <ng-container matColumnDef="investigate">
      <th mat-header-cell *matHeaderCellDef style="width: 3%"></th>
      <td mat-cell *matCellDef="let element; let i = index">
        <img *ngIf="
                element.isInvestigate && !isfirstInvestigationDone && !completed
              " class="mr-3 cursor-pointer" id="btn-clmfilter" src="../../../../assets/images/resume.png" alt=""
          (click)="acionInvestigate('investigate', element)" />
        <div *ngIf="isfirstInvestigationDone && !completed" class="d-flex justify-content-between">
          <img class="mr-3 cursor-pointer" id="btn-clmfilter" src="../../../../assets/images/EDIT.png" alt=""
            (click)="acionInvestigate('investigate', element)" />
          <img class="mr-3" id="btn-clmfilter" src="../../../../assets/images/Tick.png" alt="" />
        </div>
        <img *ngIf="completed" class="mr-3" id="btn-clmfilter" src="../../../../assets/images/fill-green-tick.png"
          alt="" />
      </td>
    </ng-container>
    <ng-container matColumnDef="priority">
      <th mat-header-cell *matHeaderCellDef>Priority</th>
      <td mat-cell *matCellDef="let element; let i = index">
        <div class="priority-tasks cursor-pointer" (click)="acionPriority('priority', element)">
          <span class="text-white">1</span>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="initColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let element; columns: initColumns; let i = dataIndex" [class.even-rows]="i % 2 == 0"
      [class.example-expanded-row]="expandedElement === element" class="example-element-row"></tr>
    <tr mat-row *matRowDef="let element; let row; columns: ['expandedDetail']" class="example-detail-row"
      [class.example-detail-expanded-row]="expandedElement === element"></tr>
    </table>
  </div>
  <div class="no-records-div" *ngIf="!hideNoRecordsMessage">
    <p cTextColor="secondary" *ngIf="paginationDataSourceShtiks.total === 0">
      No records found!
    </p>
  </div>
</div>

<div class="d-flex justify-content-between align-items-center resp-classes" [ngClass]="
      customCssClass
        ? ''
        : service.profileDetail?.account_type === 'service_provider'
        ? 'sp-list-footer'
        : 'client-list-footer'
    ">
  <!-- Col to select no. of entries -->
  <div class="select-entries" *ngIf="paginationDataSourceShtiks.total">
    <div class="d-flex align-items-center gap-2">
      <span>No. of entries</span>
      <ng-select [(ngModel)]="selectedNoOfEntries" class="pagesize-dropdown" appendTo="body" [clearable]="false"
        [searchable]="false" (change)="onSelectEntry($event)">
        <ng-option *ngFor="let no of noOfEntries" [value]="no">{{
          no
          }}</ng-option>
      </ng-select>
    </div>
    <span>
      Showing {{ paginationDataSourceShtiks.from }}-{{
      paginationDataSourceShtiks.to
      }}
      from {{ paginationDataSourceShtiks.total }} data
    </span>
  </div>
  <!-- When there will be no records. -->
  <!-- <p cTextColor="secondary" *ngIf="paginationDataSourceShtiks.total === 0">
      No records found!
    </p> -->
  <div class="resp-pagination">
    <ul class="list" *ngIf="paginationDataSourceShtiks.total">
      <li>
        <el-pagination [model]="paginationDataSourceShtiks?.current_page" (modelChange)="pagechange($event)"
          [total]="paginationDataSourceShtiks?.total" [page-count]="paginationDataSourceShtiks?.last_page"
          [page-size]="paginationDataSourceShtiks?.per_page" [layout]="['prev', 'pager', 'next']">
        </el-pagination>
      </li>
    </ul>
  </div>
</div>
</div>


<ng-template #jsonDialog let-data>
  <h2 mat-dialog-title class="dialog-header">
    JSON Viewer

    <button mat-icon-button class="close-btn" (click)="closeDialog()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content>
    <pre class="json-box">{{ formatJson(data) }}</pre>
  </mat-dialog-content>
</ng-template>